






































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { CreateSousTypeCreneauModel } from "@/api/models/typesCreneau/sousTypeCreneau";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import Categories from "@/api/models/enums/categoriesEnum";
import { droitDiffusion } from "@/api/models/droitsDiffusion/droitDiffusion";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "create-sous-type-creneau",
})
export default class CreateSousTypeCreneau extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewSousTypeCreneauSidebarActive!: boolean;
  loading = false;

  required = required;
  categories = Categories;

  newSousTypeCreneau: CreateSousTypeCreneauModel = {};

  resetForm() {
    this.newSousTypeCreneau = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.typesCreneau
      .createSousTypeCreneauOnTypeCreneau(this.$route.params.id, this.newSousTypeCreneau)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un nouveau sous-type de créneau",
            text: "Sous-type de créneau créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-sous-types-creneau");
        this.$emit("update:is-add-new-sous-type-creneau-sidebar-active", false);
        this.loading = false;
      });
  }
}
